import { ClientPortfolioDomainEnum } from "web_myplann/Infrastructure/Api/Api";

const DOMAINS_WITH_CHART: ReadonlySet<ClientPortfolioDomainEnum> = new Set([
	ClientPortfolioDomainEnum.Investments,
	ClientPortfolioDomainEnum.PensionProducts,
	ClientPortfolioDomainEnum.BuildingSavings,
	ClientPortfolioDomainEnum.Loans,
	ClientPortfolioDomainEnum.Leasing,
	ClientPortfolioDomainEnum.BusinessLoans,
	ClientPortfolioDomainEnum.Commodities,
	ClientPortfolioDomainEnum.BankingProducts,
	ClientPortfolioDomainEnum.Cryptocurrencies,
]);

export const portfolioHasChart = (
	domain: ClientPortfolioDomainEnum | undefined | null,
): boolean =>
	domain !== null && domain !== undefined && DOMAINS_WITH_CHART.has(domain);
